module.exports = __webpack_public_path__ + "static/media/ClaireandTerryICVM.a2657c6d.jpg";